import React from "react";
import { Link } from "react-router-dom";
import head from '../../assets/Vector.png';
const Navbar = () => {
  return (
    <div className="header-area">
      <div className="container md:py-[30px] py-[20px] border-b-[1px]">
        <nav className=''>
          <ul className='flex justify-between items-center gap-3'>
            <h1 className="text-xl"><span className="font-bold">Shop</span>cart</h1>
            <Link to='/singin' className="flex items-center gap-2">
              <img src={head} alt="" srcset="" />
              <span className="text-base font-medium">Sign In</span>
            </Link>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
